import React from 'react'

// styles
import './SplitDayAssignmentInput.css'

// components
import SelectField from '../../SelectField/SelectField.component'

export default function SplitDayAssignmentInput({ value, name, options = [], classification, handleChange, errors = {} }) {

    return (<div className='split-day-assignment-input'>
        <div className='split-day-assignment-input-left'>
            <div className='split-day-assignment-input-title'>{name}</div>
            <div className='split-day-assignment-input-subtitle'>{classification === 'Foreman' ? `${classification} - Will add assignment to each day` : classification}</div>
        </div>    
        <div className='split-day-assignment-input-right'>
            <SelectField 
                placeholder='Select a Day'
                options={options}
                handleChange={value => handleChange(value.value)}
                value={value}
                isValid={errors['jobDay']}
            />
        </div>
    </div>)
}